import { listenerMiddleware } from 'legacy/lut/store/middlewares/listenerMiddleware'
import { compose } from 'redux'

import { changeProgramType } from '../api/changeProgramType'
import { updateProgramType } from '../configurationSlice'
import { selectProgramType } from '../selectors/selectProgramType'
import { selectProgramTypes } from '../selectors/selectProgramTypes'

listenerMiddleware.startListening({
  actionCreator: updateProgramType,
  effect: (action, { getState, dispatch }) => {
    const programType = compose(selectProgramType, getState)()
    const programTypes = compose(selectProgramTypes, getState)()

    const offeringToUpdate = programTypes.find(
      (it) => it.programType === action.payload.programType
    )

    if (offeringToUpdate?.programType === programType) {
      const [first] = programTypes.filter((it) => it.enabled).filter((it) => !it.isDeprecated)

      dispatch(changeProgramType(first.programType))
    }
  },
})
